import gql from 'graphql-tag';

export const AddressByPostcodeQuery = gql`
    query addressesByPostcode($postcode: String!) {
        addressesByPostcode(postcode: $postcode) {
            addresses {
                uprn
                postcode
                fullAddress
            }
        }
    }
`;
